/**
===================================================
Module: frontend.src.components.visualizer.LoadingOverlay.tsx
Description: Loading overlay component for visualizer operations
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React from "react";
import { useVisualizer } from "../../contexts/VisualizerContext";
import { LoadingPhase } from "../../types/visualizer";

const LoadingOverlay: React.FC = () => {
  const { state } = useVisualizer();
  const { loadingPhase } = state;

  if (
    loadingPhase === LoadingPhase.READY ||
    loadingPhase === LoadingPhase.NAVIGATING
  ) {
    return null;
  }

  const getLoadingMessage = () => {
    switch (loadingPhase) {
      case LoadingPhase.FETCHING_SESSION_DATA:
        return "データを取得中...";
      case LoadingPhase.DOWNLOADING_MAP:
        return "マップファイルを読み込み中...";
      case LoadingPhase.DOWNLOADING_KEYFRAMES:
        return "キーフレームを読み込み中...";
      case LoadingPhase.RENDERING_COMPONENTS:
        return "3Dマップを読み込み中...";
      default:
        return "読み込み中...";
    }
  };

  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-spinner" />
        <div className="loading-text">{getLoadingMessage()}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
